import { useState } from 'react';
import styles from './language-switch.module.scss';
import Uk from '@/assets/icons/uk-icon.svg?react';
import Icon from '@ant-design/icons';

interface LanguagesSwitchProps {
  initialActive: 'original' | 'english';
  onSwitch: (translate: string) => void;
  flagUrl: string;
}

export default function LanguagesSwitch({
  initialActive = 'original',
  onSwitch,
  flagUrl,
}: LanguagesSwitchProps) {
  const [active, setActive] = useState<'original' | 'english'>(initialActive);

  const handleSwitch = (type: 'original' | 'english') => {
    const isTranslate = type === 'english' ? 'true' : 'false';
    onSwitch(isTranslate);
    setActive(type);
  };

  return (
    <div className={styles.switchContainer}>
      <button
        type="button"
        className={`${styles.switchButton} ${active === 'english' ? styles.active : styles.inactive}`}
        onClick={() => handleSwitch('english')}
      >
        <Icon
          className={`${styles.flag} ${active === 'english' ? styles.active : styles.inactive}`}
          component={() => <Uk width="20" height="20" />}
        />
      </button>
      <button
        type="button"
        className={`${styles.switchButton} ${active === 'original' ? styles.active : styles.inactive}`}
        onClick={() => handleSwitch('original')}
      >
        <div className={styles.flagContainer}>
        <img
          src={flagUrl}
          alt="Original language flag"
          width="20"
          height="20"
          className={`${styles.flag} ${active === 'original' ? styles.active : styles.inactive}`}
        />
        </div>
      </button>
    </div>
  );
}
